import BossModel from "@/models/BossModel";
import Country from "@/models/Country/Country";

export default class City extends BossModel {
    declare id: number;
    declare country_id: number;
    declare code: string;
    declare label: string;
    declare name: string;
    declare alternatenames: string;
    declare lat: string;
    declare lng: string;
    declare gmt: string;
    declare geoname_eid: string;
    declare is_active: boolean;

    /**
     *
     * @type {string}
     */
    static apiUrl = "city";

    /**
     *
     * @type {string}
     */
    static entity = "cities";

    static fields() {
        return {
            id: this.number(null).nullable(),
            country_id: this.number(null).nullable(),
            code: this.attr(null),
            label: this.attr(null),
            name: this.attr(null),
            alternatenames: this.attr(null),
            lat: this.attr(null),
            lng: this.attr(null),
            gmt: this.attr(null),
            geoname_eid: this.attr(null),
            is_active: this.boolean(null),
            country: this.belongsTo(Country, "country_id"),
        };
    }

    static search(params = { filters: {} }): Promise<City[]> {
        return this.api()
            .filtered(params.filters)
            .get()
            .then((data) => {
                const instances: City[] = [];
                for (const key in data) {
                    instances.push(new City(data[key]));
                }
                return instances;
            });
    }

    /**
     *
     * @returns {boolean|*}
     */
    Country() {
        return this.getRelated("country");
    }
}
